// LogoBar.jsx
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";
import YoutubeAdBanner from "./YouTubeBanner";

export default function LogoBar() {
    return (
        <div className="w-full bg-white px-4 lg:px-6 py-4 flex flex-col lg:flex-row 
                        justify-between items-center gap-4">

            {/* ---- LEFT LOGO ---- */}
            <header className="h-[96px] flex items-center">
                <img
                    src="/logo.png"
                    alt="TechArticleHub logo"
                    width="224"
                    height="64"
                    loading="lazy"
                    decoding="async"
                    fetchpriority="low"
                    className="object-contain select-none"
                />
            </header>
            <div>

                <YoutubeAdBanner />

            </div>
            {/* ---- RIGHT SOCIAL ICONS ---- */}
            <div className="flex items-center space-x-5 text-3xl">

                <a href="https://www.facebook.com/aicodepath"><FaFacebook className="text-[#1877F2] hover:opacity-80" aria-label="facebook" /></a>
                <a href="https://x.com/techarticlehub"><FaTwitter className="text-[#1DA1F2] hover:opacity-80" aria-label="twitter" /></a>
                <a href="https://www.instagram.com/techarticlehub"><FaInstagram className="text-[#E1306C] hover:opacity-80" aria-label="instagram" /></a>
            </div>
        </div>
    );
}
